<template>
  <div
    class="swiper_component"
    :class="component_class_list">
    <div class="swiper" ref="swiper">
      <div class="swiper-wrapper">
        <slot></slot>
      </div>
    </div>
    <template v-if="has_pagination">
      <div class="swiper-pagination" :class="pagination_class"/>
    </template>
    <template v-if="add_navigation_buttons">
      <swiper-slide-arrows
        :hide_disabled="hide_navigation_buttons"
        :class="navigation_buttons.next"
      />
      <swiper-slide-arrows
        is_prev
        :class="navigation_buttons.prev"
      />
    </template>
  </div>
</template>

<script>
import {Swiper} from 'swiper'
import {Navigation, EffectFade, Pagination, Autoplay} from "swiper/modules";
import SwiperSlideArrows from "../../small_parts/SwiperSlideArrows";

export default {
  name: "Swiper",
  components: {SwiperSlideArrows},
  props: {
    slides_per_view: {
      type: Number,
      default: 1
    },
    space_between: {
      type: Number,
      default: 20
    },
    breakpoints: {
      type: Object,
      default: null
    },
    loop: {
      type: Boolean,
      default: false
    },
    add_navigation_buttons: {
      type: Boolean,
      default: false
    },
    hide_navigation_buttons: {
      type: Boolean,
      default: false
    },
    prev_btn_class: {
      type: String,
      default: ''
    },
    next_btn_class: {
      type: String,
      default: ''
    },
    fade_effect: {
      type: Boolean,
      default: false
    },
    swiper_events: {
      type: Object,
      default: null
    },
    swiper_config: {
      type: Object,
      default: null
    },
    has_pagination: {
      type: Boolean,
      default: false
    },
    nav_buttons_inside: {
      type: Boolean,
      default: false
    },
    navigation_buttons_stripped: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pagination_class() {
      return `swiper-pagination_${this.uid}`
    },
    uid() {
      return this._uid
    },
    navigation_buttons() {
      return {
        prev: `${this.prev_btn_class}_${this.uid}`,
        next: `${this.next_btn_class}_${this.uid}`,
      }
    },
    component_class_list() {
      return {
        nav_buttons_inside: this.nav_buttons_inside,
        navigation_buttons_stripped: this.navigation_buttons_stripped,
      }
    },
  },
  data() {
    return {
      swiper: null
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      let swiper_data = {
        slidesPerView: this.slides_per_view,
        modules: [],
      }
      if (this.breakpoints) {
        swiper_data.breakpoints = this.breakpoints
      }
      if (this.loop) {
        swiper_data.loop = this.loop
      }
      if (this.add_navigation_buttons) {
        swiper_data.modules.push(Navigation)
        swiper_data.navigation = {
          nextEl: `.${this.navigation_buttons.next}`,
          prevEl: `.${this.navigation_buttons.prev}`
        }
      }
      if (this.fade_effect) {
        swiper_data.modules.push(EffectFade)
        swiper_data.effect = 'fade'
        swiper_data.fadeEffect = {
          crossFade: true
        }
      }
      if (this.swiper_config?.autoplay) {
        swiper_data.modules.push(Autoplay)
      }
      if (this.swiper_events) {
        swiper_data.on = this.swiper_events
      }
      if (this.space_between) {
        swiper_data.spaceBetween = this.space_between
      }
      if (this.has_pagination) {
        swiper_data.modules.push(Pagination)
        swiper_data.pagination = {
          el: `.${this.pagination_class}`,
          type: 'bullets',
          clickable: true
        }
      }
      this.swiper = new Swiper(
        this.$refs.swiper,
        {...swiper_data, ...(this.swiper_config || {})},
      );
    },
  },
}
</script>
